import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Articulo } from "@/shared/types/articulo";
import { getImage } from "./get-image";

export async function searchArticulo(codigo: string, includeImage: boolean = false, depositoId?: string): Promise<Articulo> {
    await sleep(500);
    const response = await api.get<Articulo>("articulos/search/" + codigo, {
        params: depositoId ? { depositoId } : undefined
    });
    if (response.data && includeImage && response.data.nombreImagen) response.data.imagen = await getImage(response.data.id);
    return response.data;
}

export function useSearchArticuloQuery(codigo: string, includeImage: boolean = false, queryConfig: QueryConfig<Articulo> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await searchArticulo(codigo, includeImage),
        queryKey: ["articulos", codigo],
    })
}

export interface SearchArticuloQueryProps {
    codigo: string,
    includeImage: boolean,
    queryConfig?: QueryConfig<Articulo>,
    children?: (queryResult: QueryResult<Articulo>) => ReactNode
}

export function SearchArticuloQuery({
    codigo,
    includeImage,
    children,
    queryConfig
}: SearchArticuloQueryProps) {
    const queryResult = useSearchArticuloQuery(codigo, includeImage, queryConfig);
    return children && children(queryResult);
}